import { isNullOrUndefined }   from 'rewire-common';
import {
  observable,
}                              from 'rewire-core';
import { IActionMenuItem }     from 'rewire-ui';
import {
  DeepPartial,
  IEmployee,
  ITimecard,
}                              from '../DataTypes';
import DataQueries             from '../graphql/Queries';
import { notifications }       from '../ui/Notifications';
import infoPanelShiftViewModel, {
  IInfoPanelShiftViewModelChangeHandler,
}                              from './InfoPanelShiftViewModel';

interface IInfoPanelShiftEmployeesViewModelState {
  employees: DeepPartial<IEmployee>[];
}

export class InfoPanelShiftEmployeesViewModel implements IInfoPanelShiftViewModelChangeHandler {
  state: IInfoPanelShiftEmployeesViewModelState;
  optionsActionMenuItems: IActionMenuItem[];

  constructor() {
    this.optionsActionMenuItems = [
      {name: 'placeholder', title: 'Placeholder', icon: undefined, onClick: undefined, closeOnClick: true, disabled: () => true},
    ];

    this.state = observable({
      employees: [],
    });
  }

  reset() {
    this.state.employees = [];
  }

  load = async () => {
    this.state.employees = await this.getGridEmployeeData();
  };

  onCurrentInnerShiftChange() {
    this.load();
  }

  get employees(): DeepPartial<IEmployee>[] {
    return this.state.employees;
  }

  get viewOnly(): boolean {
    return infoPanelShiftViewModel.viewOnly;
  }

  getGridEmployeeData = async (): Promise<DeepPartial<IEmployee>[]> => {
    const employeeIds = ([...new Set(infoPanelShiftViewModel.currentInnerShift?.details?.filter((detail: ITimecard) => detail.employee?.id).map((detail: ITimecard) => detail.employee!.id) || [])]);
    if (!employeeIds.length) {
      return [];
    }
    const returnSchema = `
      id
      name
      email
      phone {
        home
      }
    `;
    const result = await DataQueries.getEmployeesByIds(returnSchema, employeeIds);
    if (result) {
      return result.filter((employee?: DeepPartial<IEmployee>) => !isNullOrUndefined(employee)) as DeepPartial<IEmployee>[];
    } else {
      notifications.error('Error fetching employees');
      return [];
    }
  };
}

const infoPanelShiftEmployeesViewModel = new InfoPanelShiftEmployeesViewModel();
export default infoPanelShiftEmployeesViewModel;
